import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarFooterService, CclMessageService, CclDrawerService, CclRouteTab } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { cloneDeep } from "lodash";
import { EventService } from "../../../../../modules/shared/services/event.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-sessionresources-page",
    templateUrl: "./sessionresources-page.view.html",
    styleUrls: []
})
export class SessionResourcesPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    baseUrl: string;
    sessionResourceConfigObj: any;
    sessionResourceConfig: any = {};
    catalogLayoutConfig: any = {};
    fontstyle: any = {};
    baseClassUrl: string;

    constructor(
        public sharedService: SharedService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService,
        private drawerService: CclDrawerService,
        private eventService: EventService
    ) {
        super(sharedService);
        this.baseUrl = "sessionresources";
        this.baseClassUrl = "resources";
        sharedService.sessionUrl = this.baseUrl;

        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionResourceConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sharedService.currentLayoutSection = "sessionresources";
        this.sessionResourceConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION_RESOURCE_CONFIG];

        if (this.sessionResourceConfigObj == null || this.sessionResourceConfigObj.id == null) {
            this.sessionResourceConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            this.sessionResourceConfigObj = {
                id: null,
                setupId: this.sharedService.setup.id,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: {
                    "isResourceEnabled": false,
                    header: {
                        label: "Session Resources",
                        label_color: "#FBFBFB",
                        icon_color: "#FFFFFF",
                        background: "#0d2958"
                    },
                    button: {
                        primary: {
                            background: "#0d2958",
                            color: "#FBFBFB"
                        },
                        secondary: {
                            background: "#FBFBFB",
                            color: "#0d2958"
                        }
                    }
                },
                configType: this.sharedService.configTypes.SESSION_RESOURCE_CONFIG
            };
        } else {
            this.sessionResourceConfig = JSON.parse(this.sessionResourceConfigObj.config);
            this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionResourceConfig);
        }

        if (!this.sessionResourceConfig.hasOwnProperty("isResourceEnabled")) {
            this.sessionResourceConfig.isResourceEnabled = false;
        }

        if (!this.sessionResourceConfig.hasOwnProperty("header")) {
            this.sessionResourceConfig.header = {
                                            label: "Session Resources",
                                            label_color: "#FBFBFB",
                                            icon_color: "#FFFFFF",
                                            background: "#0d2958"
                                        };
        }

        if (!this.sessionResourceConfig.hasOwnProperty("button")) {
            this.sessionResourceConfig.button = {
                                            primary: {
                                                background: "#0d2958",
                                                color: "#FBFBFB"
                                            },
                                            secondary: {
                                                background: "#FBFBFB",
                                                color: "#0d2958"
                                            }
                                        };
        }

        if(!this.sessionResourceConfig.hasOwnProperty('assetConfig')) {
            this.sessionResourceConfig.assetConfig = this.sharedService.assetConfig;
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.sessionResourceConfig);
        this.sharedService.changedData = this.sessionResourceConfig;

        this.fontstyle = {
            color: this.sessionResourceConfig.header.label_color,
            "font-style": this.sessionResourceConfig.header.fontStyle,
            "text-decoration": this.sessionResourceConfig.header.fontStyle,
            "font-weight":
                this.sessionResourceConfig.header.fontStyle != "bold" ? "normal" : this.sessionResourceConfig.header.fontStyle
        };
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Data for Event Advisor section";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-sessionresources";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-sessionresources";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveSessionResourceConfig(message) {
        if (message.text == "save-sessionresources" || message.text == "save-next-sessionresources") {
            this.sessionResourceConfigObj.config = JSON.stringify(this.sessionResourceConfig);
            if(this.sessionResourceConfigObj.setupId == undefined || this.sessionResourceConfigObj.setupId == null ) {
                this.sessionResourceConfigObj.setupId = this.sharedService.setup.id;
            }
            this.catalogService.saveSetupConfig(this.sessionResourceConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionResourceConfig);
                this.sharedService.changedData = this.sessionResourceConfig;

                this.sessionResourceConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                
                this.sharedService.configs[this.sharedService.configTypes.SESSION_RESOURCE_CONFIG] = this.sessionResourceConfigObj;
                this._flashMessagesService.show("Session Resource config saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-sessionresources") {
                    this.sharedService.currentLayoutSection = "sessionrecommendationwidget";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/sessionrecommendationwidget");
                }
            });
        } else if (message.text == "apply-sessionresources-config") {
            this.sessionResourceConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            // For checking unsaved data
            this.sharedService.changedData = this.sessionResourceConfig;

            // Apply Assets Config to resources module
            // Prepare FIRST GROUP DOCUMENT TEMPLATE
            if(this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl]?.assetConfig?.firstGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.firstGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate = "<div [hidden]=\"checkIfDDFExist('first-group','{@ddf.id@}')\">" +
                `<span class="${this.baseClassUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.firstGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list first-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> <i class="{{getFileExtension(${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)})}}" aria-hidden="true">&nbsp;</i> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.documentTemplate = '';
            }

            // Prepare SECOND GROUP VIDEO TEMPLATE
            if(this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl]?.assetConfig?.secondGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.secondGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate = "<div [hidden]=\"checkIfDDFExist('second-group','{@ddf.id@}')\">" +
                `<span class="${this.baseClassUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.secondGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list second-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> <i class="{{getFileExtension(${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)})}}" aria-hidden="true">&nbsp;</i> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.videoTemplate = '';
            }

            // prepare THIRD GROUP Others Template
            if(this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty('assetConfig') && this.sharedService.sessionLayoutConfig[this.baseUrl]?.assetConfig?.thirdGroupList.length>0) {
                let AssetList =  this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdGroupList;
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate = "<div [hidden]=\"checkIfDDFExist('third-group','{@ddf.id@}')\">" +
                `<span class="${this.baseClassUrl}-session-group-header"> <strong> ${this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdGroupLabel}: </strong> </span>
                <br><div>
                <ul class="asset-list third-group-{@ddf.id@}">`
                for(let i=0; i<AssetList.length; i++) {
                    let str;
                    if(AssetList[i].value == '{@ddf.presentations@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].value == '{@ddf.abstractFile@}') {
                        str = AssetList[i].value.replace(/@/g, "*");
                    } else if (AssetList[i].type == 'text_url') {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="View" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"viewSessionDocument($event, '" + AssetList[i].value.replace(/@/g, "#") + "')\"> View  </button> </span> </li>";
                    } else {
                        str = "<li *ngIf= \"'" + AssetList[i].value.replace(/@/g, "#") + "'\" class=\"" + this.baseUrl + "-session-asset-row\"> " +
                    `<span class="${this.baseClassUrl}-session-document-label pull-left"> <i class="{{getFileExtension(${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)})}}" aria-hidden="true">&nbsp;</i> ${AssetList[i].label.charAt(0).toUpperCase() + AssetList[i].label.slice(1)} </span> <span class="pull-right"> <button title="Download" class="resources-session-download-btn" type="button"` +
                        "(cclClick)=\"downloadSessionDocument($event,'{@ddf.eventId@}', '" + AssetList[i].value.replace(/@/g, "#") + "', 'Custom','{@ddf.sessionId@}')\"> Download  </button> </span> </li>";
                    }
                    this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate + str;
                }
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate + '</ul></div></div>';
            } else {
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.thirdTemplate = '';
            }


            //Apply Session Resource drawer configurations
            this.sessionResourceConfig.button.primary.background = this.sessionResourceConfig.header.background;
            this.sessionResourceConfig.button.primary.color = this.sessionResourceConfig.header.label_color;
            this.sessionResourceConfig.button.secondary.background = this.sessionResourceConfig.header.label_color;
            this.sessionResourceConfig.button.secondary.color = this.sessionResourceConfig.header.background;
            
            this.fontstyle = {
                color: this.sessionResourceConfig.header.label_color,
                "font-style": this.sessionResourceConfig.header.fontStyle,
                "text-decoration": this.sessionResourceConfig.header.fontStyle,
                "font-weight":
                    this.sessionResourceConfig.header.fontStyle != "bold" ? "normal" : this.sessionResourceConfig.header.fontStyle
            };

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.sessionResourceConfig.header.label_color,
                    "font-style": this.sessionResourceConfig.header.fontStyle,
                    "text-decoration": this.sessionResourceConfig.header.fontStyle,
                    "font-weight":
                        this.sessionResourceConfig.header.fontStyle != "bold"
                            ? "normal"
                            : this.sessionResourceConfig.header.fontStyle
                };
            }, 0);

            this.drawerService.hideDrawer();
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionResourceConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "header") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "My Resources Header",
                navLinks: null,
                saveMessage: "apply-sessionresources-config"
            };
            url = "config-drawer/session/myresources-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-sessionresources-config"
            };
            url = "config-drawer/session/html-config";
        } else if (item == "button") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Buttons",
                navLinks: null,
                saveMessage: "apply-sessionresources-config"
            };
            url = "config-drawer/session/myresources-config";
        } else if(item == 'assets') {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Assets",
                navLinks: [
                    new CclRouteTab("Fields", "session/resource-asset-config"),
                    new CclRouteTab("Display", "session/resource-asset-display-config")
                ],
                saveMessage: "apply-sessionresources-config"
            };
            url = "config-drawer/session/resource-asset-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    toggleResourceEnabled(ev) {
        this.sessionResourceConfig.isResourceEnabled = !this.sessionResourceConfig.isResourceEnabled;
    }
}
